






import { defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
  name: "ElementsDivider",
  props: {
    tag: {
      type: String,
      default: "div",
    },
    node: {
      type: String,
      default: "div",
    },
    attr: {
      type: Object,
      default: () => {},
    },
    children: {
      type: Array,
      default: () => [],
    },
  },
});
